import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-87182a02")

_pushScopeId("data-v-87182a02")
const _hoisted_1 = { class: "change_user_info_mask" }
const _hoisted_2 = { class: "change_user_info" }
const _hoisted_3 = { class: "change_user_info_hd flex_space_center" }
const _hoisted_4 = { class: "flex_start_center" }
const _hoisted_5 = { class: "change_user_info-bd" }
const _hoisted_6 = { class: "infos" }
const _hoisted_7 = { class: "avatar-wrap" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "title" }, "我的头像", -1)
const _hoisted_9 = { class: "nickname" }
const _hoisted_10 = { class: "flex_start_center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "我的昵称：", -1)
const _hoisted_12 = {
  key: 0,
  class: "err_msg"
}
const _hoisted_13 = { class: "open_id_box" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "账号ID：", -1)
const _hoisted_15 = { class: "login_type" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 登陆方式：")
const _hoisted_17 = {
  key: 0,
  class: "login_type"
}
const _hoisted_18 = { class: "avatars_list" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "avatars_title flex_start_center" }, [
  /*#__PURE__*/_createTextVNode(" 个性头像库 "),
  /*#__PURE__*/_createVNode("span", null, " （请在下方选择您喜欢的头像） ")
], -1)
const _hoisted_20 = { class: "avatars flex_starts" }
const _hoisted_21 = {
  key: 1,
  class: "selected change_user_info-select"
}
const _hoisted_22 = { class: "change_user_info-ft flex_centers" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MoreMemberInfo = _resolveComponent("MoreMemberInfo")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.viewModel.logo,
            class: "logo_icon",
            alt: ""
          }, null, 8, ["src"]),
          _createVNode("span", null, _toDisplayString(_ctx.viewModel.title) + "-个人资料", 1)
        ]),
        _createVNode("div", {
          class: "close_btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeWindow && _ctx.closeWindow(...args)))
        })
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            (!_ctx.viewModel.avatar)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.viewModel.defaultAvatar,
                  class: "avatar"
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock("img", {
                  key: 1,
                  src: _ctx.viewModel.avatar,
                  class: "avatar",
                  onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleLoadFailAvatar && _ctx.handleLoadFailAvatar(...args)))
                }, null, 40, ["src"])),
            _hoisted_8
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("div", null, [
                _createVNode("span", null, _toDisplayString(_ctx.viewModel.nickname), 1)
              ])
            ]),
            (_ctx.viewModel.msg)
              ? (_openBlock(), _createBlock("div", _hoisted_12, "*" + _toDisplayString(_ctx.viewModel.msg), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode("span", null, _toDisplayString(_ctx.viewModel.openId), 1),
            _createVNode("span", {
              class: "copy_openid",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copyOpenId && _ctx.copyOpenId(...args)))
            }, "复制"),
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("span", null, _toDisplayString(_ctx.login_type_text_info[_ctx.viewModel.loginType]), 1)
            ]),
            (_ctx.viewModel.isVip)
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  _createTextVNode(_toDisplayString(_ctx.viewModel.priorityMemberInfo?.page_detail?.name) + "： ", 1),
                  _createVNode("span", null, _toDisplayString(_ctx.viewModel.memberDateText), 1),
                  (_ctx.viewModel.vipInfo.length)
                    ? (_openBlock(), _createBlock("span", {
                        key: 0,
                        class: "see_more",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.controlMoreVipInfoVisible(true)))
                      }, " 更多 "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode("div", _hoisted_20, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.viewModel.avatarList, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "avatar-item",
                onClick: ($event: any) => (_ctx.selectAvatar(index))
              }, [
                (item.url)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: item.url,
                      alt: ""
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                (_ctx.viewModel.avatarId === item.id)
                  ? (_openBlock(), _createBlock("div", _hoisted_21))
                  : _createCommentVNode("", true)
              ], 8, ["onClick"]))
            }), 128))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", {
          class: "btn",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitEditUserInfo && _ctx.submitEditUserInfo(...args)))
        }, "保存")
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        (_ctx.viewModel.moreMemberModalVisible)
          ? (_openBlock(), _createBlock(_component_MoreMemberInfo, {
              key: 0,
              onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.controlMoreVipInfoVisible(false)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})